define('v3/Common/Bindings/Popover.Binding',[
	'jquery',
	'knockout',
	'lodash',
	'v3/Common/Services/Frontend/Popover.Service'
], function ($, ko, _, popover) {
	ko.bindingHandlers.popover = {
		init: function (element, valueAccessor) {
			var value = (_.isObjectLike(valueAccessor())) ? valueAccessor() : valueAccessor()();

			$(element).on('click.popover', function () {
				popover(element, value);
			});
		},
		update: function (element, valueAccessor) {
			var value = (_.isObjectLike(valueAccessor())) ? valueAccessor() : valueAccessor()();

			$(element).off('click.popover').on('click.popover', function () {
				popover(element, value);
			});
		}
	};
});
